import React from 'react'
import { Switch, Route } from 'react-router-dom/cjs/react-router-dom.min'
import { Grid, makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'

import { ROUTE_404, ROUTE_ERROR, ROUTE_NOT_FOUND, ROUTE_PASSWORD_RECOVERY, ROUTE_PASSWORD_RESET, ROUTE_USER_RECOVERY } from './routes'
import { LANGUAGES_BY_BRAND } from '../../i18n'
import ComponentWrapperComponent from './componentWrapper/ComponentWrapperComponent'
import MainContent from './main-content'
import NoMatch from '../../pages/no-match/no-match'
import NotFound from '../not-found/NotFound'
import ErrorPage from '../error/ErrorPage'
import PasswordRecoveryPage from '../../pages/recovery/PasswordRecoveryPage'
import PasswordResetPage from '../../pages/recovery/PasswordResetPage'
import UserRecoveryPage from '../../pages/recovery/UserRecoveryPage'

const useStyles = makeStyles((theme) => ({
  landing: (props) => ({
    height: props.minHeight,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      minHeight: '100vh',
    },
  }),
  menuLoadingBar: {
    position: 'sticky',
    top: 0,
    width: '100%',
    float: 'left',
  },
  submenuLoadingBar: {
    position: 'sticky',
    top: 0,
    width: '100%',
    marginTop: -4,
  },
  content: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(4),
    },
  },
  centeredText: {
    top: '50%',
    textAlign: 'center',
    paddingTop: '100px',
  },
  leftAlignText: {
    display: 'flex',
    flexDirection: 'column',
    top: '50%',
    textAlign: 'left',
    paddingTop: '100px',
    maxWidth: '25%',
    minWidth: '200px',
    margin: '0 auto',
  },
  textMargin: {
    margin: '10px 0px 10px 0px',
  },
  errorImage: {
    width: '100%',
    maxWidth: '160px',
    justifyContent: 'center',
    display: 'flex',
    margin: '0 auto',
    marginBottom: '35px',
    paddingRight: '25px',
  },
  loginWrapper: {
    position: 'relative',
    borderRadius: '10px',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
    display: 'flex',
    flexDirection: 'column',
    padding: '3rem',
    paddingTop: '0.5rem',
    maxWidth: 450,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2, 2, 2),
      marginTop: theme.spacing(0),
      maxWidth: '100%',
    },
  },
  loginFormContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  gapContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  keepMeSigned: {
    marginBottom: theme.spacing(1),
  },
  forgotLink: {
    margin: theme.spacing(2, 0),
    textAlign: 'right',
    float: 'right',
  },
  pinForm: {
    marginBottom: theme.spacing(2),
  },
  ButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(3),
  },
  autoRegister: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  inputAlias: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  aliasImg: {
    maxWidth: 150,
  },
  inputContainer: {
    width: '100%',
    marginBottom: theme.spacing(3),
  },
  inlineText: {
    display: 'inline',
  },
  passForm: {
    display: 'flex',
    width: '100% !important',
  },
  flexForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  marginBottomForm: {
    marginBottom: theme.spacing(4),
  },
  recoveryUser: {
    marginBottom: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  accountImg: {
    width: '70%',
  },
  recoveryPasswordButtons: {
    marginTop: '1rem !important',
    justifyContent: 'center !important',
  },
  centeredPageContainer: {
    justifyContent: 'center',
  },
  recoverySuccessIcon: {
    color: '#4caf50',
    fontSize: 60,
    alignSelf: 'center',
  },
  datePickerContainer: {
    width: '100%',
  },
  gridContainer: {
    height: '100%',
  },
  registerForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  loginButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  },
  confirmButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: '2rem',
    marginTop: theme.spacing(3),
  },
  recoveryButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  loginPinContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  passwordRulesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  passwordRulesRow: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  passwordRulesChars: {
    marginLeft: theme.spacing(0.5),
  },
}))

const Content = ({ content }) => {
  const mobileVersion = useSelector((state) => state.reducer.mobileVersion)

  return (
    <>
      {mobileVersion ? (
        <MainContent component={content} />
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <MainContent component={content} />
          </Grid>
        </Grid>
      )}
    </>
  )
}

const Router = () => {
  const brand = useSelector((state) => state.reducer.brand)

  const numberOfLanguages = LANGUAGES_BY_BRAND[brand.abbreviation].length

  const styleProps = {
    minHeight: numberOfLanguages > 1 ? 'calc(100vh - 32px)' : '100vh',
  }

  const classes = useStyles(styleProps)

  return (
    <Switch>
      <Route exact path={ROUTE_PASSWORD_RECOVERY}>
        <ComponentWrapperComponent component={<PasswordRecoveryPage classes={classes} />} />
      </Route>
      <Route exact path={ROUTE_PASSWORD_RESET}>
        <ComponentWrapperComponent component={<PasswordResetPage classes={classes} />} />
      </Route>
      <Route exact path={ROUTE_USER_RECOVERY}>
        <ComponentWrapperComponent component={<UserRecoveryPage classes={classes} />} />
      </Route>
      <Route exact path={ROUTE_NOT_FOUND}>
        <ComponentWrapperComponent component={<NotFound classes={classes} />} />
      </Route>
      <Route exact path={ROUTE_ERROR}>
        <ComponentWrapperComponent component={<ErrorPage classes={classes} />} />
      </Route>
      <Route path={ROUTE_404}>
        <Content content={<NoMatch />} />
      </Route>
    </Switch>
  )
}

export default Router
